import { ComponentProps, SVGProps } from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactNode } from '@tanstack/react-router';
import { Button } from 'react-aria-components';
import {
  RichTextEditorActionStyles,
  richTextEditorActionStyles,
} from './variants';

type Props = {
  icon: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
} & Omit<ComponentProps<typeof Button>, 'className' | 'children'> &
  RichTextEditorActionStyles;

export function RichTextEditorAction(props: Props) {
  const {
    icon: Icon,
    className,
    onPress,
    state = 'inactive',
    color = 'grey',
    ...rest
  } = props;

  return (
    <Button
      onPress={onPress}
      className={twMerge(
        richTextEditorActionStyles({
          state,
          color,
        }),
      )}
      {...rest}
    >
      <Icon className="min-w-20 w-20 h-20" />
    </Button>
  );
}
